module.exports = __webpack_public_path__ + "static/media/logo.ab06c7f5.png";